import React, { useState } from "react";
import AppointmentCard from "./AppointmentCard";
import { DropArea } from "./DropArea";
import classNames from "classnames";
import { useLSStore } from "../../../context/ls-store";
import AppointmentCardSkeleton from "./AppointmentCardSkeleton";
import { BsLightningChargeFill } from "react-icons/bs";
import { Tooltip } from "@mui/material";
import { Icon } from "@virtuslab/tetrisly-icons";
import moment from "moment";

const DateColumn = ({
  id,
  info,
  cards,
  onDrop,
  addOpen,
  loaderVisible,
  isToday,
  publishOpen,
  containerRef,
  handleDrag,
  handleOptimise,
  handleBulkSchedule,
  user,
  appointmentTypes,
  handleVisitType,
}) => {
  const filterOpen = useLSStore((state) => state.filterOpen);
  const selectedAppointment = useLSStore((state) => state.selectedAppointment);

  return (
    <div
      className={classNames(
        "border-r border-y min-w-64 border-primarygrayborder",
        (selectedAppointment !== null ||
          filterOpen === true ||
          addOpen === true ||
          publishOpen === true) &&
          "border-opacity-40",
        !info.isAvailable && "bg-red-100"
      )}
    >
      <div
        className={classNames(
          "flex flex-col items-center group justify-center pt-3 relative min-h-[210px]",
          (selectedAppointment !== null ||
            filterOpen === true ||
            addOpen === true ||
            publishOpen === true) &&
            "opacity-40"
        )}
      >
        <div className="flex flex-col items-center group justify-center pt-3 w-full" style={{height: "73px"}}>
          <div className="flex absolute top-3 justify-between items-start w-full">
            <div className="flex flex-col gap-3">
              {user?.permissions?.includes('calendar_view.bulk_actions_cv') && <Tooltip title="Bulk scheduling actions" arrow>
                <button
                  disabled={cards.length === 0}
                  className={classNames(
                    "px-3",
                    cards.length === 0 && " opacity-40"
                  )}
                  onClick={() => {
                    if (cards.length === 0) return;
                    handleBulkSchedule({
                      date: cards[0].visitDate,
                      providerId: cards[0].provider.id,
                      count: cards.length,
                      appointments: cards,
                    });
                  }}
                >
                  <div className="flex justify-center items-center w-10 h-10 rounded-md bg-primarylightgrey">
                    <Icon name="20-view-schedule" color="#3062D4" />
                  </div>
                </button>
              </Tooltip>}
            </div>
            <div className="flex flex-col gap-3">
              {user?.permissions?.includes('calendar_view.optimize_route_cv') && <Tooltip title="Optimize Route" arrow>
                <button
                  disabled={cards.length === 0}
                  className={classNames(
                    "px-3 ml-auto",
                    cards.length === 0 && " opacity-40"
                  )}
                  onClick={() => {
                    if (cards.length === 0) return;
                    handleOptimise(cards[0].visitDate, cards[0].provider.id);
                  }}
                >
                  <div className="flex justify-center items-center w-10 h-10 rounded-md bg-primarylightgrey">
                    <BsLightningChargeFill size={20} color="#fdb53f" />
                  </div>
                </button>
              </Tooltip>}
            </div>
          </div>
          <p
            className={classNames(
              "m-0 text-lg",
              isToday ? "text-primaryblue" : "text-primaryblack",
              !info.isAvailable && "text-primaryred"
            )}
          >
            {info.day}
          </p>
          <p
            className={classNames(
              "m-0 text-2xl font-semibold pb-3",
              isToday ? "text-primaryblue" : "text-primaryblack",
              !info.isAvailable && "text-primaryred"
            )}
          >
            {info.date}
          </p>
        </div>
        {/* {!info.isAvailable && (
          <p className="absolute m-0 text-xs font-light text-center translate-y-10 text-primaryred">
            Provider might not be available{" "}
            <span className="font-extrabold">*</span>
          </p>
        )} */}
        <div className="flex flex-col w-full items-center mt-2 pt-2 border-t border-primarygrayborder" style={{height: "80px"}}>
          {cards.length > 0 ? (
            <p className="py-1 m-0 w-full text-xs font-bold text-center text-primarytextgrey" style={{height: "25px"}}>
              {cards.length} visits |{" "}
              {cards
                .reduce((total, appointment, index) => {
                  return total + (index === 0 ? 0 : +appointment.distance);
                }, +cards[0].distanceFromHome + +cards[cards.length - 1].distanceFromHome)
                .toFixed(2)}{" "}
              miles
            </p>
          ): <span style={{height: "25px"}}></span>}
          { 
            info?.availableTime?.length ? (
              info?.availableTime[0]?.isLeave 
                ? (
                  <span
                    style={{
                      backgroundColor: "#fca5a5",
                      padding: "4px 5px",
                      borderRadius: "2px",
                      color: "#991b1b",
                      fontSize: "12px",
                      width: "180px",
                      margin: '5px auto',
                      textAlign: 'center'
                    }}
                  >
                    Unavailable
                  </span>
                ) : (
                  info?.availableTime[0]?.type == 'partial'
                    ? (
                      <span
                        style={{
                          backgroundColor: "#fff4c7",
                          padding: "4px 5px",
                          borderRadius: "2px",
                          color: "#d8821c",
                          fontSize: "12px",
                          width: "180px",
                          margin: '5px auto',
                          textAlign: 'center'
                        }}
                      >
                        {info?.availableTime?.map(e => e?.title?.replace(' to ', ' - '))?.join(', ')}
                      </span>
                    ) : (
                      <span
                        style={{
                          backgroundColor: "#dbeafe",
                          padding: "4px 5px",
                          borderRadius: "2px",
                          color: "#1e40af",
                          fontSize: "12px",
                          width: "180px",
                          margin: '5px auto',
                          textAlign: 'center'
                        }}
                      >
                        {info?.availableTime?.map(e => e?.title?.replace(' to ', ' - '))?.join(', ')}
                      </span>
                    )
                )
            ) : <span
                  style={{
                    backgroundColor: "#fca5a5",
                    padding: "4px 5px",
                    borderRadius: "2px",
                    color: "#991b1b",
                    fontSize: "12px",
                    width: "150px",
                    margin: '5px auto',
                    textAlign: 'center'
                  }}
                >
                  Unavailable
                </span>
          }
        </div>
      </div>
      <div
        className={classNames(
          "w-full h-[1px] bg-primarygrayborder",
          (selectedAppointment !== null ||
            filterOpen === true ||
            addOpen === true ||
            publishOpen === true) &&
            "opacity-40",
          !info.isAvailable && "h-[1px] bg-primaryred"
        )}
      />
      {loaderVisible ? (
        <div className="flex flex-col px-2 pb-3">
          <DropArea onDrop={() => onDrop(id, 0, info.isAvailable)} />
          {Array(7)
            .fill(0)
            .map((_, indx) => (
              <React.Fragment key={indx}>
                <AppointmentCardSkeleton indx={indx} />
                <DropArea
                  onDrop={() => onDrop(id, indx + 1, info.isAvailable)}
                />
              </React.Fragment>
            ))}
        </div>
      ) : (
        <div className="flex flex-col px-2 pb-3">
          {moment(info.fulldate).isSameOrAfter(moment(), "date") && (
            <DropArea onDrop={() => onDrop(id, 0, info.isAvailable)} />
          )}
          {cards &&
            cards.map((card, indx) => (
              <React.Fragment key={indx}>
                <AppointmentCard
                  {...card}
                  indx={indx}
                  addOpen={addOpen}
                  isLastVisit={cards.length - 1 === indx}
                  publishOpen={publishOpen}
                  appointment={card}
                  containerRef={containerRef}
                  handleDrag={handleDrag}
                  appointmentTypes={appointmentTypes}
                  handleVisitType={handleVisitType}
                  appointmentDate={info.fulldate}
                  user={user}
                />
                {moment(info.fulldate).isSameOrAfter(moment(), "date") && (
                  <DropArea
                    onDrop={() => onDrop(id, indx + 1, info.isAvailable)}
                  />
                )}
              </React.Fragment>
            ))}
        </div>
      )}
    </div>
  );
};

export default DateColumn;
